import Button from '../base';
import freezeWidth from '../../HOC/freezeWidth';

const FreezeWidthButton = freezeWidth(Button);

FreezeWidthButton.propTypes = Button.propTypes;
FreezeWidthButton.defaultProps = Button.defaultProps;

export default FreezeWidthButton;
